<template>
  <div class="mb-2">
    <b-form-row class="spnod-admin__account--row">
      <b-col>
        <b-form-input
          name="firstName"
          type="text"
          placeholder="First Name"
          v-model="parent.firstName"
        />
      </b-col>
      <b-col>
        <b-form-input
          name="lastName"
          type="text"
          placeholder="Last Name"
          v-model="parent.lastName"
        />
      </b-col>
    </b-form-row>
    <b-form-row class="spnod-admin__account--row">
      <b-col>
        <b-form-input
          name="email"
          type="email"
          placeholder="Email"
          v-model="parent.email"
        />
      </b-col>
      <b-col>
        <b-form-input
          name="phone"
          type="text"
          placeholder="Phone"
          v-model="parent.phone"
        />
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
export default {
  name: 'ParentFormBasic',
  props: ['parent', 'index']
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/ParentFormBasic.vue?c2b8bd66